//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orderBy } from 'lodash';

export default {
    name: "ResidentNotification",

    data: function data() {
        return {
            subject: '',
            message: '',
            properties: [],
            notifications: [],
            selectedProperty: {},
            sending: false,
            sent: false
        };
    },
    created: function created() {
        this.getProperties();
        this.getNotifications();
    },


    computed: {
        sortedProperties: function sortedProperties() {
            var sortedProperties = orderBy(this.properties, ['label'], 'asc');

            if (window.user.role === 'super-admin' || window.user.role === 'regional-manager') {
                sortedProperties.unshift({ id: 999, label: 'All Properties' });
            }

            return sortedProperties;
        },
        sortedNotifications: function sortedNotifications() {
            return orderBy(this.notifications, ['created_at'], ['desc']);
        }
    },

    methods: {
        getNotifications: function getNotifications() {
            var _this = this;

            axios.get('/prototype/residents/notifications').then(function (res) {
                _this.notifications = res.data;
            }).catch(function (err) {
                //
            });
        },
        sendNotification: function sendNotification() {
            var _this2 = this;

            if (this.subject === '' || this.message === '') {
                if (this.subject === '') {
                    this.$snotify.error('Subject line can not be empty');
                }

                if (this.message === '') {
                    this.$snotify.error('Subject line can not be empty');
                }

                return;
            }

            this.sending = true;
            this.$snotify.info('Sending message to all residents at ' + this.selectedProperty.label);

            axios.post('/api/residents/notify', { propertyId: this.selectedProperty.id, message: this.message, subject: this.subject }).then(function (res) {
                _this2.$snotify.success('Message was sent!');
                _this2.sending = false;
                _this2.sent = true;
                _this2.getNotifications();
            }).catch(function (err) {
                _this2.$snotify.error('There was an error, please try again');
            });
        },
        getProperties: function getProperties() {
            var _this3 = this;

            axios.get('/prototype/notifications/properties').then(function (res) {
                var propertyList = [];

                res.data.map(function (property) {
                    propertyList.push({ id: property.id, label: property.name });
                });

                _this3.properties = orderBy(propertyList, ['label'], 'asc');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentNotification.vue
// module id = Z7Dv
// module chunks = 0 1